import * as PIXI from "pixi.js";
import { ArrayUtil } from "../../../util/collection/ArrayUtil";
import { SpriteProperties } from "./SpriteProperties";
/**
 * MovieClipProperties.ts
 */
export class MovieClipProperties extends SpriteProperties {
    constructor(id, spriteSheet, numberOfFrames, position = new PIXI.Point(0, 0), scale = new PIXI.Point(1, 1), anchor = new PIXI.Point(0, 0), rotation = 0) {
        super(id, spriteSheet, position, scale, anchor, rotation);
        this.numberOfFrames = numberOfFrames;
        this.loop = false;
    }
    equals(other) {
        return super.equals(other) &&
            (this.numberOfFrames === other.numberOfFrames) &&
            (this.loop === other.loop) &&
            ArrayUtil.equals(this.frameNames, other.frameNames);
    }
}
//# sourceMappingURL=MovieClipProperties.js.map